export enum CollegeZone {
	Northwest = 'nw',
	Northeast = 'ne',
	CenterCuyo = 'cc',
	SouthPampa = 'sp',
	GreatBuenosAires = 'gba',
}